import { Component, type ErrorInfo, type ReactNode } from 'react';
import { BrowserRouter, Link, Navigate, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { HomePage } from './pages/HomePage';
import { DesignerPage } from './pages/DesignerPage';
import { AdminPage } from './pages/AdminPage';
import { UserPanelPage } from './pages/UserPanelPage';

export default function App() {
  return <BrowserRouter><div className="app" dir="rtl"><Header /><AppErrorBoundary><Routes><Route path="/" element={<HomePage />} /><Route path="/design" element={<DesignerPage />} /><Route path="/account" element={<UserPanelPage />} /><Route path="/admin" element={<AdminPage />} /><Route path="*" element={<Navigate to="/" replace />} /></Routes></AppErrorBoundary><footer className="site-footer"><span>© ۱۴۰۵ کارو لایت — طراح هوشمند نور</span><a href="https://karolightcompany.com" target="_blank" rel="noreferrer">karolightcompany.com</a></footer></div></BrowserRouter>;
}

class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error('UI render failure', error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="route-error" role="alert"><h1>نمایش این صفحه با مشکل روبه‌رو شد</h1><p>اطلاعات جلسه شما محفوظ است. دوباره وارد صفحه طراحی شوید.</p><div><button className="primary-button" onClick={() => this.setState({ failed: false })}>تلاش دوباره</button><Link className="secondary-button" to="/">بازگشت به صفحه اصلی</Link></div></main>;
  }
}
